import React from 'react'

const NiList = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 6L20 6" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"></path><path opacity="0.6" d="M4 12L12 12" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"></path><path d="M4 18L16 18" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"></path></svg>
  )
}

export default NiList
